import { Auth } from 'aws-amplify';
import { useContext, useEffect, useState } from 'react';
import { useGetUserQuery, UserType } from '../../../graphql/types';
import { UserTypeContext } from '../../../UserTypeContext';

/** Keep access tied to the signed-in subject; do not use a saved client role as authority. */
export default function useMemberDashboardAccess() {
  const { state: { userType } } = useContext(UserTypeContext);
  const [subject, setSubject] = useState<string>();
  const [identityError, setIdentityError] = useState<Error>();
  useEffect(() => {
    let current = true;
    setSubject(undefined);
    setIdentityError(undefined);
    if (userType === UserType.ChamberMemberAdmin) {
      Auth.currentAuthenticatedUser().then(user => {
        if (current) setSubject(user.attributes.sub);
      }).catch(() => { if (current) setIdentityError(new Error('Your sign-in could not be verified.')); });
    }
    return () => { current = false; };
  }, [userType]);
  const query = useGetUserQuery({
    variables: { userId: subject || '' }, skip: !subject || userType !== UserType.ChamberMemberAdmin,
    fetchPolicy: 'network-only', pollInterval: 30000, notifyOnNetworkStatusChange: true,
  });
  const user = !query.error && subject && query.data?.getUser.id === subject && userType === UserType.ChamberMemberAdmin
    ? query.data.getUser : undefined;
  return { user, access: user?.cmpMemberDashboardAccess, loading: (!subject && !identityError) || query.loading,
    error: identityError || query.error, refetch: query.refetch };
}
